export default __webpack_public_path__ + "static/media/floor.6e674403.png";